import styled from "@emotion/styled";
import { Button } from "antd";
import { colors } from "@unlikelyai-magic/ui/variables";
import { buttonStyles } from "../../styles";
import { ButtonProps } from "../../types";

export type DangerButtonProps = ButtonProps;

export const DangerButton = styled(({ size, ...props }: DangerButtonProps) => (
  <Button {...props} size="middle" type="default" />
))`
  ${({ size = "md" }) => buttonStyles[size]};
  color: ${colors.white};
  background: ${colors.red["500"]};
  --antd-wave-shadow-color: ${colors.red["500"]};

  &:hover,
  &:focus,
  &.ant-btn-loading {
    color: ${colors.white};
    background: ${colors.red["600"]};
  }

  &:disabled,
  &:disabled:hover {
    color: ${colors.white};
    background: ${colors.red["400"]};
  }
`;
